module.exports = __webpack_public_path__ + "img/xmqx.152e7fb2.png";